<template>
  <div
    v-if="show"
    class="fixed inset-0 z-[60] w-screen overflow-y-auto"
    role="dialog"
    aria-modal="true"
    aria-labelledby="apple-biometric-save-title"
  >
    <!-- This backdrop is visual only. Headless UI's full-screen dialog layer
         can consume touch events in WKWebView before they reach the buttons. -->
    <div data-testid="biometric-backdrop" class="pointer-events-none fixed inset-0 bg-black/80" aria-hidden="true" />

    <div class="relative z-10 flex min-h-dvh items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <div
        :class="
          twMerge(
            'relative my-8 min-w-96 max-w-[400px] space-y-4 rounded-lg border border-primary bg-background p-6 text-left shadow-xl',
            theme === 'teal' && !highContrast && 'border-theme-teal',
            theme === 'teal' && highContrast && 'border-theme-teal-hc',
            theme === 'grape' && !highContrast && 'border-theme-grape',
            theme === 'grape' && highContrast && 'border-theme-grape-hc',
            theme === 'iceberg' && !highContrast && 'border-theme-iceberg',
            theme === 'iceberg' && highContrast && 'border-theme-iceberg-hc',
            theme === 'rose' && !highContrast && 'border-theme-rose',
            theme === 'rose' && highContrast && 'border-theme-rose-hc',
            theme === 'offsite' && !highContrast && 'border-theme-offsite',
            theme === 'offsite' && highContrast && 'border-theme-offsite-hc',
          )
        "
      >
        <h2 id="apple-biometric-save-title" class="text-lg font-semibold leading-none tracking-tight">
          {{ title }}
        </h2>

        <p class="text-sm text-muted-foreground">{{ description }}</p>

        <div class="flex gap-3">
          <button
            data-testid="biometric-decline"
            type="button"
            class="inline-flex w-full touch-manipulation justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300"
            @click.stop="emit('decline')"
          >
            {{ declineLabel }}
          </button>

          <button
            data-testid="biometric-confirm"
            type="button"
            :class="confirmClass"
            class="inline-flex w-full touch-manipulation justify-center rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm"
            @click.stop="emit('confirm')"
          >
            {{ confirmLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { twMerge } from "tailwind-merge";

withDefaults(
  defineProps<{
    show: boolean;
    title: string;
    description: string;
    declineLabel: string;
    confirmLabel: string;
    confirmClass?: string;
    theme?: string;
    highContrast?: boolean;
  }>(),
  {
    confirmClass: "",
    theme: "rose",
    highContrast: false,
  },
);

const emit = defineEmits<{
  decline: [];
  confirm: [];
}>();
</script>
